"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamoDbEntityType = void 0;
var DynamoDbEntityType;
(function (DynamoDbEntityType) {
    DynamoDbEntityType["GAME"] = "GAME";
    DynamoDbEntityType["GAME_DETAIL"] = "GAME_DETAIL";
    DynamoDbEntityType["GAME_LIBRARY"] = "GAME_LIBRARY";
    DynamoDbEntityType["GAME_COUPON"] = "GAME_COUPON";
    DynamoDbEntityType["GAME_LOAD"] = "GAME_LOAD";
    DynamoDbEntityType["GAME_START"] = "GAME_START";
    DynamoDbEntityType["GAME_CLICK"] = "GAME_CLICK";
    DynamoDbEntityType["GAME_COUPON_CLICK"] = "GAME_COUPON_CLICK";
    DynamoDbEntityType["GAME_ROUND"] = "GAME_ROUND";
    DynamoDbEntityType["GAME_HIGH_SCORE"] = "GAME_HIGH_SCORE";
    DynamoDbEntityType["GAME_USER_BASE"] = "GAME_USER_BASE";
    DynamoDbEntityType["TUTORIAL"] = "TUTORIAL";
    DynamoDbEntityType["CHEATER"] = "CHEATER";
    DynamoDbEntityType["FORM_RESPONSE"] = "FORM_RESPONSE";
    DynamoDbEntityType["QUIZ_QUESTION"] = "QUIZ_QUESTION";
    DynamoDbEntityType["QUIZ_ANSWER"] = "QUIZ_ANSWER";
    DynamoDbEntityType["EXTERNAL_LEADER_BOARD"] = "EXTERNAL_LEADER_BOARD";
    DynamoDbEntityType["WELCOME_EMAIL"] = "WELCOME_EMAIL";
    DynamoDbEntityType["GAME_LUCK_BASED_WIN"] = "GAME_LUCK_BASED_WIN";
    DynamoDbEntityType["GAME_WINNER"] = "GAME_WINNER";
    DynamoDbEntityType["GAME_LUCK_BASED_WINNER"] = "GAME_LUCK_BASED_WINNER";
    DynamoDbEntityType["GAME_LUCK_BASED_WINNER_IP"] = "GAME_LUCK_BASED_WINNER_IP";
    DynamoDbEntityType["GAME_COUPON_COUNTER"] = "GAME_COUPON_COUNTER";
    DynamoDbEntityType["LINK"] = "LINK";
    DynamoDbEntityType["PLAYER_ADVENTURE"] = "PLAYER_ADVENTURE";
    DynamoDbEntityType["PLAYER"] = "PLAYER";
    DynamoDbEntityType["PLAYER_ORG"] = "PLAYER_ORG";
    DynamoDbEntityType["PLAYER_NOTIFICATION"] = "PLAYER_NOTIFICATION";
    DynamoDbEntityType["PLAYER_REWARD"] = "PLAYER_REWARD";
    DynamoDbEntityType["PLAYER_COIN_LIMIT"] = "PLAYER_COIN_LIMIT";
    DynamoDbEntityType["PLAYER_GAMIFICATION"] = "PLAYER_GAMIFICATION";
    DynamoDbEntityType["PLAYER_GAMIFICATION_CONDITION"] = "PLAYER_GAMIFICATION_CONDITION";
    DynamoDbEntityType["PLAYER_WEBHOOK_EVENT"] = "PLAYER_WEBHOOK_EVENT";
    DynamoDbEntityType["INGO_CURRENT_LEADER_BOARD"] = "INGO_CURRENT_LEADER_BOARD";
    DynamoDbEntityType["INGO_LEADER_BOARD"] = "INGO_LEADER_BOARD";
    DynamoDbEntityType["INGO_PUBLISH_WINNER"] = "INGO_PUBLISH_WINNER";
    DynamoDbEntityType["GAME_CENTER_DETAIL"] = "GAME_CENTER_DETAIL";
    DynamoDbEntityType["GAME_CENTER_EMAIL"] = "GAME_CENTER_EMAIL";
    DynamoDbEntityType["GAME_CENTER_REWARD_SETTINGS"] = "GAME_CENTER_REWARD_SETTINGS";
    DynamoDbEntityType["GAME_CENTER_USER_BASE"] = "GAME_CENTER_USER_BASE";
    DynamoDbEntityType["GAME_CENTER_POPUP"] = "GAME_CENTER_POPUP";
    DynamoDbEntityType["GAME_CENTER_AD_MODULE"] = "GAME_CENTER_AD_MODULE";
    DynamoDbEntityType["GAME_CENTER_GAME_MODULE"] = "GAME_CENTER_GAME_MODULE";
    DynamoDbEntityType["GAME_CENTER_TEXT_MODULE"] = "GAME_CENTER_TEXT_MODULE";
    DynamoDbEntityType["GAME_CENTER_REWARD_MODULE"] = "GAME_CENTER_REWARD_MODULE";
    DynamoDbEntityType["GAME_CENTER_REWARD"] = "GAME_CENTER_REWARD";
    DynamoDbEntityType["GAME_CENTER_COUPON"] = "GAME_CENTER_COUPON";
    DynamoDbEntityType["GAME_CENTER_PLAYER"] = "GAME_CENTER_PLAYER";
    DynamoDbEntityType["GAME_CENTER_PLAYER_VERIFICATION"] = "GAME_CENTER_PLAYER_VERIFICATION";
    DynamoDbEntityType["GAME_CENTER_COUPON_REDEEM"] = "GAME_CENTER_COUPON_REDEEM";
    DynamoDbEntityType["GAME_CENTER_GAMIFICATION"] = "GAME_CENTER_GAMIFICATION";
    DynamoDbEntityType["ASSET_FONT"] = "ASSET_FONT";
    DynamoDbEntityType["ASSET_STUDIO_TERM"] = "ASSET_STUDIO_TERM";
    DynamoDbEntityType["ASSET_GAME_TERM"] = "ASSET_GAME_TERM";
    DynamoDbEntityType["ASSET_BRAND_TERM"] = "ASSET_BRAND_TERM";
    DynamoDbEntityType["ASSET_BRAND_EMAIL"] = "ASSET_BRAND_EMAIL";
    DynamoDbEntityType["ASSET_BRAND_FORM_PARAMETER"] = "ASSET_BRAND_FORM_PARAMETER";
    DynamoDbEntityType["ASSET_BRAND_TIMEZONE"] = "ASSET_BRAND_TIMEZONE";
    DynamoDbEntityType["ASSET_BRAND_ACCESSKEY"] = "ASSET_BRAND_ACCESSKEY";
    DynamoDbEntityType["ASSET_BRAND_SECRET_KEY"] = "ASSET_BRAND_SECRET_KEY";
    DynamoDbEntityType["ASSET_HELP_ICON"] = "ASSET_HELP_ICON";
    DynamoDbEntityType["ASSET_GUIDE_BUTTON"] = "ASSET_GUIDE_BUTTON";
    DynamoDbEntityType["LICENSE"] = "LICENSE";
    DynamoDbEntityType["CONSUMED_EVENT_LOG"] = "CONSUMED_EVENT_LOG";
    DynamoDbEntityType["USER_BASE_EMAIL"] = "USER_BASE_EMAIL";
    DynamoDbEntityType["GAMIFICATION"] = "GAMIFICATION";
    DynamoDbEntityType["GAMIFICATION_CONDITION"] = "GAMIFICATION_CONDITION";
    DynamoDbEntityType["WEBHOOK"] = "WEBHOOK";
    DynamoDbEntityType["WEBHOOK_RESOURCE"] = "WEBHOOK_RESOURCE";
    DynamoDbEntityType["RECEIPT_DETAIL"] = "RECEIPT_DETAIL";
    DynamoDbEntityType["RECEIPT_CONDITION"] = "RECEIPT_CONDITION";
    DynamoDbEntityType["RECEIPT_STORE"] = "RECEIPT_STORE";
    DynamoDbEntityType["RECEIPT_STYLE"] = "RECEIPT_STYLE";
    DynamoDbEntityType["RECEIPT_PRODUCT"] = "RECEIPT_PRODUCT";
    DynamoDbEntityType["UPLOAD_RECEIPT"] = "UPLOAD_RECEIPT";
    DynamoDbEntityType["UPLOAD_RECEIPT_PRODUCT"] = "UPLOAD_RECEIPT_PRODUCT";
    DynamoDbEntityType["UPLOAD_RECEIPT_VALIDATION"] = "UPLOAD_RECEIPT_VALIDATION";
    DynamoDbEntityType["GAME_LIBRARY_TEMPLATE"] = "GAME_LIBRARY_TEMPLATE";
    DynamoDbEntityType["GAME_LIBRARY_TAG_RELATION"] = "GAME_LIBRARY_TAG_RELATION";
    DynamoDbEntityType["GAME_LIBRARY_TAG"] = "GAME_LIBRARY_TAG";
})(DynamoDbEntityType || (exports.DynamoDbEntityType = DynamoDbEntityType = {}));
